import React from 'react'
import ReactModal from 'react-modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { useAppType } from '../../context/AppContext'
import { BRANDS } from '../../utils/brand'
import './PandaModal.scss'

type Props = {
  isOpen: boolean
  onClose: () => void
  actionLabel: string
  onAction?: () => void
  title?: React.ReactNode
  badge?: IconDefinition
  children?: React.ReactNode
}

const c = 'panda-modal'

const PandaModal = ({
  isOpen,
  onClose,
  actionLabel,
  onAction,
  title,
  badge,
  children,
}: Props) => {
  const appType = useAppType()

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
      ariaHideApp={false}
      closeTimeoutMS={220}
      className={c}
      overlayClassName={`${c}-overlay`}
      bodyOpenClassName={`${c}-open`}
    >
      <div className={`${c}__art`}>
        <img src={BRANDS[appType].mascot} alt='' />
        {badge && (
          <span className={`${c}__badge`}>
            <FontAwesomeIcon icon={badge} />
          </span>
        )}
      </div>
      {title && <h2 className={`${c}__title`}>{title}</h2>}
      <div className={`${c}__body`}>{children}</div>
      <button className={`${c}__action`} onClick={onAction ?? onClose}>
        {actionLabel}
      </button>
    </ReactModal>
  )
}

export default PandaModal
